/**
 * Performance Chart Component
 * 
 * Displays performance metrics using a bar chart
 * - Shows event counts by type
 * - Displays performance comparisons
 * 
 * Requirements: 5.5
 */

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export interface PerformanceData {
  category: string;
  value: number;
  label?: string;
}

interface PerformanceChartProps {
  data: PerformanceData[];
  title?: string;
  dataKey?: string;
  barColor?: string;
}

export function PerformanceChart({ 
  data, 
  title = 'Performance Metrics',
  dataKey = 'value',
  barColor = '#435d7d'
}: PerformanceChartProps) {
  return (
    <div className="w-full">
      <h3 className="text-lg font-semibold text-primary-900 mb-4">{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 5, right: 5, left: -20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis 
            dataKey="category" 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <YAxis 
            stroke="#6b7280"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '8px',
            }}
          />
          <Legend 
            wrapperStyle={{ fontSize: '14px' }}
          />
          <Bar
            dataKey={dataKey}
            fill={barColor}
            radius={[8, 8, 0, 0]}
            name="Count"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
